// Cookie consent for Google Analytics (GDPR/RODO). Nothing from Google
// Analytics is loaded until the visitor clicks "Accept"; the choice is kept
// in localStorage and can be changed via "Cookie settings" in the footer.
import Vue from 'vue';
import { splitLocalePath } from './i18n/locales';

const GA_ID = 'G-K9MNHGB8CK';
const STORAGE_KEY = 'emdr-consent-analytics';

function readChoice() {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === 'granted' || value === 'denied' ? value : null;
  } catch (e) {
    return null;
  }
}

// choice: null (not asked yet) | 'granted' | 'denied'
export const consentState = Vue.observable({
  choice: readChoice(),
  settingsOpen: false,
});

// The patient screen is a client's in-session view: never track it, in any
// language (/patient, /pl/patient, ...).
export function isPatientRoute(path) {
  return splitLocalePath(path).path === '/patient';
}

let analyticsLoaded = false;

function loadAnalytics() {
  // Re-enables sending if consent was withdrawn and given again on this page.
  window[`ga-disable-${GA_ID}`] = false;
  if (analyticsLoaded) return;
  analyticsLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

// Removes the _ga cookies GA set on this host or its parent domain.
function clearAnalyticsCookies() {
  const host = window.location.hostname;
  const domains = ['', host, `.${host}`, `.${host.split('.').slice(-2).join('.')}`];
  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    if (name === '_ga' || name.indexOf('_ga_') === 0) {
      domains.forEach((domain) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain ? `; domain=${domain}` : ''}`;
      });
    }
  });
}

// Called on every route change; loads GA only with consent.
export function applyConsent(path) {
  if (consentState.choice === 'granted' && !isPatientRoute(path)) {
    loadAnalytics();
  }
}

export function setConsent(choice, path) {
  consentState.choice = choice;
  consentState.settingsOpen = false;
  try {
    window.localStorage.setItem(STORAGE_KEY, choice);
  } catch (e) {
    // localStorage unavailable - the banner will simply ask again next visit
  }
  if (choice === 'granted') {
    applyConsent(path);
  } else {
    // Withdrawal: stop the already-loaded tag from sending and drop cookies.
    window[`ga-disable-${GA_ID}`] = true;
    clearAnalyticsCookies();
  }
}

export function openConsentSettings() {
  consentState.settingsOpen = true;
}
